export const facebooklink = "https://www.facebook.com/tiffanyhuongnghiep";
